import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getEnquire, removeEnquire } from 'slice/enquireSlice';
import { Link } from 'react-router-dom';

const List = () => {
    const dispatch = useDispatch();
    const enquireData = useSelector((state) => state.enquire);
    const userData = useSelector((state) => state.user);

    const headers = {
        'Authorization': `Bearer ${userData?.token}`,
    };

    useEffect(() => {
        dispatch(getEnquire({ headers }));
    }, [dispatch]);

    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this enquiry?')) {
            dispatch(removeEnquire(id));
        }
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Khajuraho Routes Enquiries</h4>
            </div>
            <div className="mt-4 px-4 bg-white rounded shadow-sm py-4 overflow-auto">
                <table className="table table-striped table-hover">
                    <thead className="thead-dark">
                        <tr>
                            <th>#</th>
                            <th>Client Details</th>
                            <th>Travelers</th>
                            <th>Travel Date</th>
                            <th>City</th>
                            <th>Message</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {enquireData?.data?.length > 0 ? (
                            enquireData.data.map((item, index) => (
                                <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <strong>{item.name}</strong><br/>
                                        <small className="text-muted">{item.email}</small><br/>
                                        <small className="text-muted">{item.number || item.phone || item.mobile}</small>
                                    </td>
                                    <td>{item.travelers || '-'}</td>
                                    <td>{item.travelDate || '-'}</td>
                                    <td>{item.city || '-'}</td>
                                    <td>
                                        <div style={{ maxWidth: '200px', fontSize: '0.85rem' }}>
                                            {item.message}
                                        </div>
                                    </td>
                                    <td>
                                        <span className={`badge badge-${item.status === 'pending' ? 'warning' : 'success'}`}>
                                            {item.status}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="btn-group">
                                            <Link 
                                                to={`/khajuraho/enquiries/update/${item.id}`} 
                                                className="btn btn-primary btn-sm mr-2"
                                            >
                                                Edit
                                            </Link>
                                            <button 
                                                className="btn btn-danger btn-sm" 
                                                onClick={() => handleDelete(item.id)}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className="text-center">No enquiries found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default List;
